import client from "./client";

export default {
    async getLeases(filters) {
        return client.parseResponse(await client.get('/leases', filters));
    },
    async getLease(id) {
        return client.parseResponse(await client.get('/leases/' + id));
    },
    async getLeasePreview(data) {
        return client.parseResponse(await client.post('/leases/preview-lease', data));
    },
    async uploadLeaseDocument(data) {
        return client.parseResponse(await client.post('/upload', data));
    },
    async generateUrl(data) {
        return client.parseResponse(await client.post('/generate-document-url', data));
    },
    async createLease(data) {
        return client.parseResponse(await client.post('/leases', data));
    },
    async editLease(data) {
        return client.parseResponse(await client.put('/leases/' + data.id, data));
    },
    async signLease(id) {
        return client.parseResponse(await client.post('/leases/' + id + '/sign'));
    },
    async deleteLease(id) {
        return client.parseResponse(await client.delete('/leases/' + id));
    },

    async exportLeasesReport(filters) {
        return client.parseResponse(await client.get('/export-leases', filters, {responseType: 'blob'}));
    }
}
